<template>
  <el-card class="custom-overlayer-info">
    <div slot="header" class="clearfix">
      <el-button
        style="float: right; padding: 3px 0"
        icon="el-icon-close"
        type="text"
        @click="$emit('close')"
      ></el-button>
    </div>
    <div class="custom-overlayer-info__content">
      <div class="info-wrap">
        <div class="left">
          <div>
            <img :src="pic" />
          </div>
        </div>
        <div class="right">
          <div>
            <span class="label">{{ '设备名:' | translateTo(i18nPath) }}</span>
            <span>{{ deviceName }}</span>
          </div>
          <div>
            <span class="label">{{ '机构名称:' | translateTo(i18nPath) }}</span>
            <span>{{ officeName }}</span>
          </div>
          <div>
            <span class="label">{{ '状态:' | translateTo(i18nPath) }}</span>
            <span class="state-text ${this.colors[state]}">
              {{ pointState[state] | translateTo('device.state') }}
            </span>
          </div>
        </div>
      </div>
      <div class="operation">
        <el-button
          type="text"
          size="mini"
          @click="toTrackPage"
          v-if="authMenu['010428']"
          :disabled="isDisabled"
        >
          {{ '设备轨迹' | translateTo(i18nPath) }}
        </el-button>
        <el-button type="text" size="mini" @click="pushToData" :disabled="isDisabled">
          {{ '监控页面' | translateTo(i18nPath) }}
        </el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
import ctt from '@/utils/const';
import { pointState } from '@/utils/dict';
import { getDeviceTypeImg } from '@/utils/deviceUtils/index';

export default {
  props: ['state', 'sn', 'deviceType', 'deviceName', 'officeName'],
  data() {
    return {
      i18nPath: 'monitor.scene',
      pointState,
      colors: {
        '-1': 'unconnect-color',
        0: 'success-color',
        1: 'warning-color',
        2: 'danger-color',
        61: 'fix-color',
        71: 'fault-color',
        81: 'collect-color'
      }
    };
  },
  computed: {
    isDisabled() {
      return this.state === undefined || this.state === ctt.POINT_STATE_UNCONNECT;
    },
    pic() {
      return getDeviceTypeImg(this.deviceType).picture;
    }
  },
  methods: {
    toTrackPage() {
      this.$router.push({
        name: 'DeviceTrack',
        params: {
          sn: this.sn,
          deviceType: this.deviceType
        }
      });
    },
    pushToData() {
      this.$router.push({
        name: 'Realdata',
        params: {
          sn: this.sn,
          deviceType: this.deviceType
        }
      });
    }
  }
};
</script>

<style lang="scss">
.info-wrap {
  display: flex;

  .left {
    img {
      width: 100px;
    }
  }

  .right > div {
    line-height: 26px;

    .label {
      margin-right: 5px;
    }
  }
}
</style>
